import { useCallback, useEffect, useRef, useState } from 'react';
import useCalendar from '../useCalendar';
import { DEFAULT_MAX_MONTH_INDEX } from '../constants/dates';
import getMonthIndex from '../utils/getMonthIndex';
import getMonthsInView from '../utils/getMonthsInView';
var DEBOUNCE_TIMEOUT = 100;
var scrollTimeout;
function useScroll() {
    var _a = useCalendar(), firstValidMonth = _a.firstValidMonth, maxMonthIndex = _a.maxMonthIndex, monthIndex = _a.monthIndex, _b = _a.monthsLength, monthsLength = _b === void 0 ? DEFAULT_MAX_MONTH_INDEX : _b, monthsToShow = _a.monthsToShow, monthWidth = _a.monthWidth, startMonth = _a.startMonth, onDisplayMonthsChange = _a.onDisplayMonthsChange, setMonthIndex = _a.setMonthIndex, setTabClose = _a.setTabClose;
    var scrollBoxDOMNode = useRef();
    var scrollContainerDOMNode = useRef();
    var _c = useState(monthIndex <= 0), disableLeftArrow = _c[0], setDisableLeftArrow = _c[1];
    var _d = useState(monthIndex + monthsToShow >= monthsLength), disableRightArrow = _d[0], setDisableRightArrow = _d[1];
    var _e = useState(false), shouldScroll = _e[0], setShouldScroll = _e[1];
    var dispatchMonthsInView = useCallback(function () {
        if (!scrollBoxDOMNode || !scrollBoxDOMNode.current) {
            return;
        }
        var calendarWrapper = scrollBoxDOMNode.current.children[0] || null;
        var monthsInView = getMonthsInView(startMonth, calendarWrapper, scrollContainerDOMNode.current);
        onDisplayMonthsChange(monthsInView);
        return monthsInView;
    }, [scrollBoxDOMNode, scrollContainerDOMNode]);
    var onArrowFocus = useCallback(function () {
        setTabClose(true);
    }, []);
    var scrollCalendar = useCallback(function () {
        setShouldScroll(false);
        if (scrollContainerDOMNode === null || scrollContainerDOMNode === void 0 ? void 0 : scrollContainerDOMNode.current) {
            scrollContainerDOMNode.current.scrollLeft = monthIndex * monthWidth;
        }
    }, [scrollContainerDOMNode, monthIndex, monthWidth]);
    var scrollLeft = useCallback(function (evt) {
        evt === null || evt === void 0 ? void 0 : evt.preventDefault();
        setMonthIndex(function (prev) { return prev - 1; });
        setDisableLeftArrow(monthIndex <= 1);
        setDisableRightArrow(false);
        setShouldScroll(true);
    }, [monthIndex, dispatchMonthsInView]);
    var scrollRight = useCallback(function (evt) {
        evt === null || evt === void 0 ? void 0 : evt.preventDefault();
        setMonthIndex(function (prev) { return prev + 1; });
        setDisableLeftArrow(false);
        setDisableRightArrow(monthIndex >= maxMonthIndex - monthsToShow + 1);
        setShouldScroll(true);
    }, [monthIndex, maxMonthIndex, dispatchMonthsInView]);
    var onScroll = useCallback(function () {
        if (scrollTimeout) {
            clearTimeout(scrollTimeout);
        }
        scrollTimeout = setTimeout(function () {
            var months = dispatchMonthsInView();
            var newMonthIndex = getMonthIndex(firstValidMonth, months);
            setMonthIndex(newMonthIndex);
            setDisableLeftArrow(newMonthIndex <= 0);
            setDisableRightArrow(newMonthIndex >= maxMonthIndex - monthsToShow + 2);
        }, DEBOUNCE_TIMEOUT);
    }, [firstValidMonth, dispatchMonthsInView]);
    useEffect(function () {
        if (shouldScroll) {
            scrollCalendar();
            dispatchMonthsInView();
        }
    }, [shouldScroll]);
    return {
        monthIndex: monthIndex,
        scrollBoxDOMNode: scrollBoxDOMNode,
        scrollContainerDOMNode: scrollContainerDOMNode,
        disableLeftArrow: disableLeftArrow,
        disableRightArrow: disableRightArrow,
        onArrowFocus: onArrowFocus,
        onScroll: onScroll,
        scrollLeft: scrollLeft,
        scrollRight: scrollRight,
    };
}
export default useScroll;
//# sourceMappingURL=useScroll.js.map